/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Creative preview, tag, and dimension chrome used on lists and editors.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {ButtonsModule} from 'ngx-bootstrap/buttons';
import {TabsModule} from 'ngx-bootstrap/tabs';

import {AppSharedModule} from '../common/app-shared.module';
import {AdnSelectModule} from '../common/directives/adn-select/adn-select.module';
import {FormControlsModule} from '../common/directives/form-controls/form-controls.module';
import {CreativeDimsOutputComponent} from '../common/controller/creative-dims-output-component';
import {CreativeAdvertiserMismatchFixComponent} from './creative-advertiser-mismatch-fix.component';
import {CreativePreviewModalComponent} from './creative-preview-modal.component';
import {CreativePreviewComponent} from './ad/creative-preview.component';
import {CreativePreviewViaLayoutComponent} from './ad/creative-preview-via-layout.component';
import {CreativePreviewViaIdComponent} from './ad/creative-preview-via-id.component';
import {CreativeRenderedComponent} from './ad/creative-rendered.component';
import {CreativeDirectComponent} from './ad/creative-direct.component';
import {ContainFullScreenPreviewDirective} from './ad/contain-full-screen-preview.directive';
import {CreativeTagComponent} from './creative-tag.component';

const CREATIVE_PREVIEW = [
  CreativePreviewComponent,
  CreativePreviewViaLayoutComponent,
  CreativePreviewViaIdComponent,
  CreativeRenderedComponent,
  CreativeDirectComponent,
  ContainFullScreenPreviewDirective,
  CreativePreviewModalComponent,
  CreativeAdvertiserMismatchFixComponent,
  CreativeTagComponent,
  CreativeDimsOutputComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    UIRouterModule,
    ButtonsModule,
    TabsModule,
    AdnSelectModule,
    FormControlsModule
  ],
  declarations: CREATIVE_PREVIEW,
  exports: CREATIVE_PREVIEW
})
export class CreativePreviewModule {
}
